$shm_hitalama_quick $mol_view
	item* $shm_hitalama_quick_item_contract
	drag_start_event*? null
	drag_end_event*? null
	drag_pan* null
	some_dragged false
	hovered_id? \
	auto /
		<= keydown_listener $shm_listener /
			\keydown
			<= keydown_handler null
	sub /
		<= Panel $mol_view 
			style * width <= full_width_px \
			sub /
				^ buttons /
					<= Drag*0 $shm_hitalama_quick_item
						on_drag_start? <=> on_drag_start*? null
						on_drag_end? <=> on_drag_end*? null
						dragged => dragged*
						y 0
						left? <=> x*? 0
						sub /
							- <= Button* $mol_button_minor
							<= Button* $mol_check
								checked? <=> checked*? false
								sub /
									<= Speck* $mol_view
										sub / <= key* \1
									<= label* \
						event *
							pointerenter? <=> pointerenter*? null
							pointerleave? <=> pointerleave*? null
				^ remove_area_visible /
					<= Remove_area $mol_view
						sub /
							<= Cut_icon $mol_icon_trash_can
							\Удалить
						attr *
							remove_area_active <= remove_area_active? false
				^ hovered_title_visible /
					<= Hovered_title $mol_view
						sub / <= hovered_title \hovered_title
	- attr *
		popover \manual
